module.exports = __webpack_public_path__ + "static/media/usa-outline.7d99d1d2.png";